import { connect, ConnectedProps } from 'react-redux';
import { createSelector } from 'reselect';
import { StateType } from '../../state/reducers';

const foldersSelector = (state: StateType) => state.folders.folders;

const hasFolders = createSelector(
  foldersSelector,
  (folders) => Object.keys(folders).length > 0,
);

const mapState = (state: StateType) => ({
  hasFolders: hasFolders(state),
});

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
